import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

function FeedUrlInput({ value, onChange, error, disabled = false }) {
  const { t } = useTranslation('ecommerce')

  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <div className="space-y-2">
      <label htmlFor="feed-url" className="block text-sm font-medium text-gray-700">
        {t('feed.urlLabel', 'Feed URL')}
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            className="h-5 w-5 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
            />
          </svg>
        </div>
        <input
          id="feed-url"
          type="url"
          value={value}
          onChange={handleChange}
          disabled={disabled}
          placeholder={t('feed.urlPlaceholder', 'https://example.com/feed.xml')}
          aria-label={t('feed.urlLabel', 'Feed URL')}
          aria-invalid={!!error}
          aria-describedby={error ? 'feed-url-error' : 'feed-url-helper'}
          className={`
            block w-full pl-10 pr-3 py-2 border rounded-lg
            focus:ring-primary-500 focus:border-primary-500
            disabled:bg-gray-100 disabled:cursor-not-allowed
            ${error ? 'border-red-300 text-red-900' : 'border-gray-300'}
          `}
        />
      </div>
      {error ? (
        <p id="feed-url-error" className="text-sm text-red-600" role="alert">
          {error}
        </p>
      ) : (
        <p id="feed-url-helper" className="text-sm text-gray-500">
          {t('feed.urlHelper', 'Enter the URL to your XML feed (Google Shopping format)')}
        </p>
      )}
    </div>
  )
}

FeedUrlInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FeedUrlInput
